var _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClearSearch = function SvgClearSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "clear_search_svg__a",
    d: "M7.807.193c.28.28.252.763-.064 1.079L5.015 4l2.728 2.728c.287.287.337.712.133.998l-.069.081c-.28.28-.763.252-1.079-.064L4 5.015 1.272 7.743c-.316.316-.799.344-1.08.064-.28-.28-.25-.763.065-1.079L2.985 4 .257 1.272C-.03.985-.08.56.124.274L.193.193c.28-.28.763-.252 1.079.064L4 2.985 6.728.257c.316-.316.799-.344 1.08-.064z",
    className: "clear_search_svg__avoid-fill"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "clear_search_svg__avoid-fill"
  }, /*#__PURE__*/React.createElement("g", {
    className: "clear_search_svg__avoid-fill"
  }, /*#__PURE__*/React.createElement("g", {
    className: "clear_search_svg__avoid-fill"
  }, /*#__PURE__*/React.createElement("g", {
    className: "clear_search_svg__avoid-fill"
  }, /*#__PURE__*/React.createElement("g", {
    className: "clear_search_svg__avoid-fill",
    transform: "translate(8 8)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "clear_search_svg__b",
    fill: "#fff",
    className: "clear_search_svg__avoid-fill"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clear_search_svg__a",
    className: "clear_search_svg__avoid-fill"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clear_search_svg__a",
    fill: "#0A3847",
    fillRule: "nonzero",
    className: "clear_search_svg__avoid-fill",
    style: {
      mixBlendMode: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clear_search_svg__avoid-fill",
    mask: "url(#clear_search_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8-8h24v24H-8z",
    className: "clear_search_svg__avoid-fill"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClearSearch);
export default ForwardRef;